import { thumbHashToDataURL } from "thumbhash";

/**
 * Converts a base64-encoded ThumbHash (as provided by the API)
 * into a PNG data URL usable as an image placeholder.
 */
export function thumbHashDataUrl(thumbHash?: string | null): string | undefined {
    if (!thumbHash) {
        return undefined;
    }

    try {
        // Decode base64 in a way that works identically in Node and browsers
        // (`Uint8Array.fromBase64` is browser-only and would cause a hydration
        // mismatch when the placeholder is missing from the server-rendered
        // HTML). `atob` is global in both.
        const bytes = Uint8Array.from(atob(thumbHash), (char) => char.charCodeAt(0));
        return thumbHashToDataURL(bytes);
    } catch {
        return undefined;
    }
}
